//According to process.env.NODE_ Env switch different baseurl
const isPro = process.env.NODE_ENV === 'production'

module.exports = {
    // 'apis'： vue.config.js Proxy set in
    baseURL: isPro ? '/api' : '/api' 
}